import styled from "@emotion/styled";
import CloseIcon from "@mui/icons-material/Close";
import {IconButton, Modal} from "@mui/material";
import {Bindings} from "data/constants/bindings";
import {useViewController} from "data/services/locator";
import {observer} from "mobx-react";
import React, {SyntheticEvent} from "react";
import {Exist} from "views/components/exist/exist.component";
import {ModalCloseBlock, ModalContent} from "views/components/modals/common";
import {IModalTutorialController} from "views/components/modals/modal_tutorial/modal_tutorial.controller";
import {ModalTutorialLastStep} from "views/components/modals/modal_tutorial/modal_tutorial_last_step.component";
import {ModalTutorialStepOne} from "views/components/modals/modal_tutorial/modal_tutorial_step_one.component";
import {TutorialSlider} from "views/components/tutorial_slider/tutorial_slider.component";
import {AdobeDTM} from "data/utils/AdobeDTM";

const Content = styled.div`
	width: 100%;
	min-height: 500px;
`;

const SModalContent = styled(ModalContent)`
	padding: 16px;
	max-width: 420px;
`;

export const ModalTutorial: React.FC = observer(() => {
	const {close, onPlay, isOpen, isSliderStep, isFirstStep, isLastStep} =
		useViewController<IModalTutorialController>(Bindings.ModalTutorialController);

	const playCallback = (e: SyntheticEvent<HTMLButtonElement>) => {
		AdobeDTM.trackAction({
			"action.name": `Spinball: Welcome Modal ${e.currentTarget.innerText} Click`,
			"action.element.text": e.currentTarget.innerText,
		});
		onPlay();
	};

	const closeCallback = (e: SyntheticEvent<HTMLButtonElement>) => {
		AdobeDTM.trackAction({
			"action.name": `Spinball: Welcome Modal ${e.currentTarget.innerText} Click`,
			"action.element.text": e.currentTarget.innerText,
		});
		close();
	};

	return (
		<Modal open={isOpen}>
			<SModalContent>
				<ModalCloseBlock>
					<IconButton sx={{minWidth: 0}} onClick={close}>
						<CloseIcon color={"inherit"} />
					</IconButton>
				</ModalCloseBlock>

				<Content>
					<Exist when={isFirstStep}>
						<ModalTutorialStepOne onPlay={closeCallback} onGuide={playCallback} />
					</Exist>
					<Exist when={isSliderStep}>
						<TutorialSlider />
					</Exist>
					<Exist when={isLastStep}>
						<ModalTutorialLastStep onPlay={closeCallback} onRestart={playCallback} />
					</Exist>
				</Content>
			</SModalContent>
		</Modal>
	);
});
